import React from 'react';
import { Table } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

interface TableSkeletonProps {
  rows: number;
  cols: number;
}
export const TableSkeleton = ({
  rows,
  cols,
  children,
}: React.PropsWithChildren<TableSkeletonProps>) => {
  return (
    <Table bordered hover>
      {children && <thead>{children}</thead>}
      <tbody>
        {Array.from({ length: rows }, (_, i) => (
          <tr key={i}>
            {Array.from({ length: cols }, (_, j) => (
              <td key={j}>
                <Skeleton count={1} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
